module.exports = __webpack_public_path__ + "img/configurazione_invio_mail_invoiceweb.25753dd3.png";